<script lang="ts">
	import DateRangeFilter from './DateRangeFilter.svelte';
	import FacetOptions from './FacetOptions.svelte';

	let {
		mode = 'default',
		title,
		name,
		options,
		selectedItems = $bindable(),
	}: {
		mode: 'default' | 'range';
		title: string;
		name: string;
		options: Record<string, number>;
		selectedItems: string[];
	} = $props();
</script>

<details>
	<summary class="filter__heading">{title}</summary>
	{#if options}
		{#if mode === 'default'}
			<FacetOptions mode="mobile" {name} {options} bind:selectedItems />
		{:else if mode === 'range'}
			<DateRangeFilter facetDistribution={options} />
		{/if}
	{/if}
</details>
<div>
	<div class="filter__heading">{title}</div>
	{#if options}
		{#if mode === 'default'}
			<FacetOptions mode="desktop" {name} {options} bind:selectedItems />
		{:else if mode === 'range'}
			<DateRangeFilter facetDistribution={options} />
		{/if}
	{/if}
</div>
